import session from 'lib/api/links/session';
import { LOGIN_URL } from 'lib/appConfig';

// Plain fetch, not rawRequest: rawRequest treats 401 as a dead session. Every non-2xx is a decision
// about the guest, returned as data. Operator consent is company-keyed on the server.
export const brokerEmbeddedCredential = async (request, { approve } = {}) => {
  const token = session.getApiKey();
  if (!token) {
    return { status: 401, body: { error: 'invalid_token' } };
  }
  const res = await fetch(`${LOGIN_URL}/oauth/embedded/credential`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      clientId: request.clientId,
      origin: request.origin,
      scope: request.scope,
      ...(approve === true ? { approve: true } : {}),
    }),
  });
  let body;
  try {
    body = await res.json();
  } catch (e) {
    throw new Error(
      `embedded credential broker: non-JSON ${res.status} response`
    );
  }
  return { status: res.status, body };
};

export default brokerEmbeddedCredential;
